import React from 'react';
import { Helmet } from 'react-helmet';
import classes from './NotFound.css';

class NotFound extends React.Component{

    render(){

        return (
            <div className={ classes.NotFound }>

            <Helmet>
            <title>404 Page Not Found | BookMeeY</title>
            <meta name="description" content="The page you are looking for is no longer here." />
            </Helmet>
                <div className={ classes.NotFoundBox }>
                    <h1>404</h1>
                    <h3>Page Not Found | BookMeeY</h3>
                    <p>The page you are looking for is no longer here.</p>
                </div>
            </div>
                        
        );
    }
}

export default NotFound;


// WEBPACK FOOTER //
// ./src/components/NotFound/NotFound.js